import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FamilyHealthStatus} from '../enums/family-health-status.enum';
import {mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FamilyHealthService {
  status: FamilyHealthStatus;
  url: string;
  consulted = false;
  canceled = false;
  constructor(private http: HttpClient) {
  }

  getFamilyHealthStatus(){
    if (this.status){
      return of(this.status);
    }else {
      this.http.get('/accounts/customers/health/status').pipe(
        mergeMap(
          (response: any) => {
            this.status = response.healthSubscriptionStatus;
            if (this.status === FamilyHealthStatus.NOT_CREATED || this.status === FamilyHealthStatus.CANCELLED ){
              return this.http.get('/accounts/customers/health/url').pipe(
                mergeMap( (response1: any) => {
                    this.url = response1.url;
                    return of(response);
                  }
                )
              );
            }
            return of(response);
          })
      ).subscribe(
        (response: any) => {
      }, error => {
      }
      );
    }
  }
  getFamilyHealthUrl() {
    this.http.get('/accounts/customers/health/url').subscribe(
      (response: any) => {
        this.url = response?.url;
      }, error => {
      }
    );
  }
  cancelFamilyHealth() {
    return this.http.put('/accounts/customers/health/cancel', null);
  }

  logout(){
    this.status = null;
    this.url = null;
    this.consulted = false;
    this.canceled = false;
  }

}
